
import { Component, Vue, Prop} from 'vue-property-decorator';
import UndueHardshipFsSurvey from "./UndueHardshipFSSurvey.vue";
import PageBase from "../../PageBase.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import { stepInfoType, stepResultInfoType } from "@/types/Application";

@Component({
    components:{
        UndueHardshipFsSurvey,
        PageBase
    }
})
export default class UndueHardshipFS extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = true;

    undueHardshipFsExists = null;  

    debtData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('undue-hardship-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(childValue) {

        const currentIndexValue = this.debtData?.length > 0 ? this.debtData[this.debtData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...childValue, id };
        this.debtData = [...this.debtData, newChild];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
       
        this.debtData = this.debtData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.debtData = this.debtData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    created() {

        if (this.step.result?.undueHardshipFsExists) {
            this.undueHardshipFsExists = this.step.result.undueHardshipFsExists;
        }

        if (this.step.result?.undueHardshipFSSurvey?.data) {
            this.debtData = this.step.result.undueHardshipFSSurvey.data;
        }
             
    }

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
    }

    public surveyHasError(){
        let progress = this.debtData.length==0? 50 : 100;
        
        if(this.undueHardshipFsExists == 'No') progress =100;

        this.incompleteError =  false;        
        for(const debt of this.debtData){
            if ((this.undueHardshipFsExists=='Yes') && 
                (!debt.creditorFullName || !debt.debtReason || !debt.debTotal || !debt.debtAnnualPayment)){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }    

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (!this.undueHardshipFsExists || 
            (this.undueHardshipFsExists == 'Yes') 
            && this.debtData?.length <= 0 );
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let debtInfo = this.getDebtResults()        
        
        if(this.undueHardshipFsExists == 'No')
            debtInfo = null
        
        this.UpdateStepResultData(
            {
                step:this.step, 
                data: {
                    undueHardshipFsExists: this.undueHardshipFsExists,
                    undueHardshipFSSurvey: debtInfo
                }
            }
        )       
    }

    public getDebtResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const debt of this.debtData)
        {
            questionResults.push({name:'undueHardshipFSSurvey', value: this.getDebtInfo(debt), title:'Debt '+debt.id +' Information', inputType:''})
        }
        
        return {data: this.debtData, questions:questionResults, pageName:'Debt Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getDebtInfo(debt){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+(debt.creditorFullName));
        resultString.push(Vue.filter('styleTitle')("Borrowing reason: ")+(debt.debtReason));
        resultString.push(Vue.filter('styleTitle')("Debt Total: ")+(debt.debTotal));
        resultString.push(Vue.filter('styleTitle')("Annual Payment: ")+(debt.debtAnnualPayment));

        return resultString
    } 
    
}
